// extracted by mini-css-extract-plugin
module.exports = {"cardinfo":"page_cardinfo__Z3FIi","rowcardinfo":"page_rowcardinfo__drw3F","icon":"page_icon__uqxfP"};